import type { User } from 'firebase/auth';

import { resolveFrontendApiBase } from './apiBase';
import { getAuthHeaders } from './authHeaders';

export type AccountEmailSyncResult = {
  status: 'success';
  email: string;
  firestoreUpdated: boolean;
  stripeCustomersChecked: number;
  stripeCustomersUpdated: number;
};

export async function syncVerifiedAccountEmail(
  user: User,
): Promise<AccountEmailSyncResult | null> {
  if (!user.email || !user.emailVerified) {
    return null;
  }

  const authHeaders = await getAuthHeaders(user);
  const response = await fetch(`${resolveFrontendApiBase()}/sync-email`, {
    method: 'POST',
    headers: {
      ...authHeaders,
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error(`Account email synchronization failed with status ${response.status}.`);
  }
  return response.json();
}
